import React, { useState } from 'react';
import { motion } from 'framer-motion';

interface NumberLineProps {
  number: number;
  onFactorCheck: (factor: number) => void;
}

export const NumberLine: React.FC<NumberLineProps> = ({ number, onFactorCheck }) => {
  const [selectedNumber, setSelectedNumber] = useState<number | null>(null);
  const numbers = Array.from({ length: number }, (_, i) => i + 1);

  const handleNumberClick = (n: number) => {
    setSelectedNumber(n);
    onFactorCheck(n);
  };

  return (
    <div className="overflow-x-auto">
      <div className="flex space-x-2 min-w-max p-4">
        {numbers.map((n) => (
          <motion.button
            key={n}
            onClick={() => handleNumberClick(n)}
            className={`
              w-12 h-12 rounded-full flex items-center justify-center
              ${selectedNumber === n ? 'bg-white text-[#4558C8]' : 'bg-white/20'}
              hover:bg-white hover:text-[#4558C8] transition-colors
            `}
            whileTap={{ scale: 0.95 }}
          >
            {n}
          </motion.button>
        ))}
      </div>
    </div>
  );
};